export default __webpack_public_path__ + "static/media/Icon2.70640e27.svg";